import { TreeInstance } from '@headless-tree/core';
import { createContext } from 'react';

import { InternalTreeItem } from './types';

export const TreeValueContext = createContext<
  TreeInstance<InternalTreeItem> | undefined
>(undefined);

export const TreeDispatchContext = createContext<
  React.Dispatch<
    React.SetStateAction<TreeInstance<InternalTreeItem> | undefined>
  >
>(() => {});
